module.exports = __webpack_public_path__ + "static/toolbox-Active-24ad2d668e4a8b040c7f6ac6d21fa7ab.jpg";